import React from 'react'

import { Item, Content, Date, Title, Excerpt, ReadMore } from './styles.js'

class NewsItem extends React.Component {

    render() {

        const uid = this.props.data.uid;
        const date = this.props.data.first_publication_date;
        const title = this.props.data.data.title.text;
        const excerpt = this.props.data.data.content.text;

        return (
            <Item>
                <Content>
                    <Date>{date}</Date>
                    <Title>{title}</Title>
                    <Excerpt>{excerpt.substr(0, 260) + '...'}</Excerpt>
                    <ReadMore to={`/news/${uid}`}>Read More</ReadMore>
                </Content>
            </Item>
        )
    }

}

export default NewsItem